import { Position } from "../api";

export function PositionsPanel({
  positions,
  bridgeConnected,
}: {
  positions: Position[];
  bridgeConnected: boolean;
}) {
  return (
    <section className="bg-surface border border-border rounded p-4 h-full">
      <div className="flex items-baseline justify-between mb-3">
        <h2 className="text-sm uppercase tracking-wider text-fg-muted">
          Open positions
        </h2>
        <span className="text-xs text-fg-muted font-mono">
          {positions.length} open
        </span>
      </div>

      {!bridgeConnected ? (
        <p className="text-fg-muted text-sm">bridge offline — cannot fetch positions</p>
      ) : positions.length === 0 ? (
        <p className="text-fg-muted text-sm">no open positions</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm font-mono">
            <thead className="text-xs uppercase text-fg-muted">
              <tr className="border-b border-border">
                <th className="text-left py-2 pr-3">Ticket</th>
                <th className="text-left py-2 pr-3">Symbol</th>
                <th className="text-left py-2 pr-3">Side</th>
                <th className="text-right py-2 pr-3">Lot</th>
                <th className="text-right py-2 pr-3">Open</th>
                <th className="text-right py-2 pr-3">SL</th>
                <th className="text-right py-2 pr-3">TP</th>
                <th className="text-right py-2 pr-3">P/L</th>
              </tr>
            </thead>
            <tbody>
              {positions.map((p) => (
                <tr key={p.ticket} className="border-b border-border/60">
                  <td className="py-1 pr-3 text-fg-muted">#{p.ticket}</td>
                  <td className="py-1 pr-3">{p.symbol}</td>
                  <td
                    className={`py-1 pr-3 uppercase ${p.side === "buy" ? "text-success" : "text-danger"}`}
                  >
                    {p.side}
                  </td>
                  <td className="py-1 pr-3 text-right">{p.volume.toFixed(2)}</td>
                  <td className="py-1 pr-3 text-right">{p.price_open.toFixed(5)}</td>
                  <td className="py-1 pr-3 text-right text-fg-muted">
                    {p.sl ? p.sl.toFixed(5) : "—"}
                  </td>
                  <td className="py-1 pr-3 text-right text-fg-muted">
                    {p.tp ? p.tp.toFixed(5) : "—"}
                  </td>
                  <td
                    className={`py-1 pr-3 text-right ${p.profit >= 0 ? "text-success" : "text-danger"}`}
                  >
                    {p.profit >= 0 ? "+" : ""}
                    {p.profit.toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
